export const ID_VERIFICATION_VALID_DAYS = 365;
export const ID_VERIFICATION_WARN_DAYS = 30;
const DAY_MS = 24 * 60 * 60 * 1000;
export function idVerificationExpiresAt(user) {
    if (user.idVerifiedAt == null)
        return null;
    return user.idVerifiedAt + ID_VERIFICATION_VALID_DAYS * DAY_MS;
}
export function idVerificationFreshness(user, now = Date.now()) {
    if (!user.idVerified || user.idVerifiedAt == null)
        return "missing";
    const expiresAt = user.idVerifiedAt + ID_VERIFICATION_VALID_DAYS * DAY_MS;
    if (expiresAt <= now)
        return "expired";
    if (expiresAt - now <= ID_VERIFICATION_WARN_DAYS * DAY_MS)
        return "expiring_soon";
    return "fresh";
}
/**
 * Whether staff may treat the customer's ID as checked: the assessment page shows "Sjekket" on
 * exactly these, and an offer for a store check-in is sent only on one of them.
 */
export function hasCurrentIdCheck(user, now = Date.now()) {
    const freshness = idVerificationFreshness(user, now);
    return freshness === "fresh" || freshness === "expiring_soon";
}
